import type { ReactNode } from 'react';

import { EmptyStateIconStyled, EmptyStateRootStyled } from './empty-state.styled';

import { Typography, Stack } from '@mui/material';

export type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
  actions?: ReactNode;
};

export const EmptyState = (props: EmptyStateProps) => {
  const { title, description, icon, className, actions } = props;

  return (
    <EmptyStateRootStyled className={className}>
      {icon && <EmptyStateIconStyled>{icon}</EmptyStateIconStyled>}
      <Typography color="text.primary" variant="body1" fontWeight={600}>
        {title}
      </Typography>
      {description && (
        <Typography color="text.secondary" variant="body2" maxWidth={300}>
          {description}
        </Typography>
      )}
      {actions && (
        <Stack marginTop={1} direction="row" gap={1}>
          {actions}
        </Stack>
      )}
    </EmptyStateRootStyled>
  );
};
